// Feature flags for gs_web.
//
// Xero is now GA. The flag is kept so it can be force-disabled with
// REACT_APP_XERO_ENABLED=false during an incident; default is enabled in
// every build (dev and production).
const env = process.env.REACT_APP_XERO_ENABLED;

export const XERO_ENABLED = env === undefined ? true : env === 'true';
